"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSiteCardConnectGatewayCredentials = exports.readSiteCardConnectGatewayCredentials = exports.refreshSiteCardConnectStatus = exports.requestSiteCardConnectSignature = exports.createSiteCardConnectMerchant = exports.saveSiteCardConnect = exports.readSiteCardConnect = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.readSiteCardConnect = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/read-site-cardconnect"
});
exports.saveSiteCardConnect = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/save-site-cardconnect"
});
exports.createSiteCardConnectMerchant = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/create-site-cardconnect-merchant"
});
exports.requestSiteCardConnectSignature = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/request-site-cardconnect-signature"
});
exports.refreshSiteCardConnectStatus = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/refresh-site-cardconnect-status"
});
exports.readSiteCardConnectGatewayCredentials = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/read-site-cardconnect-gateway-credentials"
});
exports.saveSiteCardConnectGatewayCredentials = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "payment/save-site-cardconnect-gateway-credentials"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/payment/site-cardconnect-client.ts
// module id = 995
// module chunks = 0 1 2